import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, OnInit, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnimationOptions } from 'ngx-lottie';
import { PlagiarismCheckerService } from 'projects/shared/src/services/plagiarism-checker.service';
import { SwalService } from 'projects/shared/src/services/swal.service';

export interface DialogData {
  service: string,
  serviceTarget: string,
  record: any,
  paraphra: string
}

@Component({
  selector: 'app-course-plagiarism-process',
  templateUrl: './course-plagiarism-process.component.html',
  standalone: false
})
export class CoursePlagiarismProcessComponent implements OnInit {
  progress = 0;
  loading = false;
  options: AnimationOptions = {
    path: '/assets/js/plagiarism_check_animation.json',
    loop: true
  };

  constructor(
    public dialogRef: MatDialogRef<CoursePlagiarismProcessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private service: PlagiarismCheckerService,
    private swalService: SwalService
  ) { }

  ngOnInit() {
    console.log(this.data);

    this.saveRecord();
  }

  saveRecord() {
    this.loading = true;
    this.progress = 0;
    const service = this.data.service
    service[this.data.serviceTarget](this.data.record).subscribe((res) => {
      if (res.type === HttpEventType.UploadProgress) {
        this.progress = Math.round((100 * res.loaded) / res.total);
      } else if (res instanceof HttpResponse) {
        this.progress = 0;
        this.loading = false;
        this.dialogRef.close(res);
      }
      // console.log(this.progress)
    }, err => {
      this.loading = false;
      const errors = JSON.parse(err.detail);
      let message = '';
      if (err.detail) {
        errors.ErrorDTO.forEach((error) => {
          if (error.Error) {
            message = error.Error;
          }
        });
      } else {
        message = err.title;
      }
      this.swalService.swalFailed(message).then((result) => {
        this.dialogRef.close();
      });
      this.handleErrors(err.detail);
    });
  }

  handleErrors(errors) {
    errors = JSON.parse(errors);
  }

}
